import { formatCurrency } from '../../lib/formatters';

/** Pure view-model for the Needs Syndication page (10/27). `data` = GET /syndications-outstanding/needs. */
export const STAGE_META = {
  not_started: { label: 'Not started', chip: 'bg-slate-100 text-slate-700', hint: 'no positions, no offer out' },
  partial: { label: 'Partly placed', chip: 'bg-sky-100 text-sky-700', hint: 'positions exist, % still available, no offer out' },
  offer_out: { label: 'Offer out', chip: 'bg-blue-100 text-blue-700', hint: 'waiting on replies or adjustments' },
  ready_to_confirm: { label: 'Ready to confirm', chip: 'bg-emerald-100 text-emerald-700', hint: 'every invitee answered' },
  no_commission: { label: 'No commission', chip: 'bg-red-100 text-red-700', hint: 'attach the broker commission first' },
};
export const STAGE_ORDER = ['not_started', 'partial', 'offer_out', 'ready_to_confirm', 'no_commission'];

export function tilesFromNeeds(t) {
  if (!t) return [];
  const c = (k) => (t[k] || {}).count || 0;
  return [
    { key: 'all', value: t.total || 0, label: 'Deals not fully placed', sub: `${formatCurrency(t.available_funding || 0)} still to place`, warn: (t.total || 0) > 0 },
    { key: 'not_started', value: c('not_started'), label: 'Not started', sub: `${formatCurrency((t.not_started || {}).funding || 0)} funded`, warn: c('not_started') > 0 },
    { key: 'partial', value: c('partial'), label: 'Partly placed', sub: 'no offer out', warn: false },
    { key: 'offer_out', value: c('offer_out'), label: 'Offers out', sub: `${t.awaiting_replies || 0} waiting · ${t.adjustments_pending || 0} to approve`, warn: (t.adjustments_pending || 0) > 0 },
    { key: 'ready_to_confirm', value: c('ready_to_confirm'), label: 'Ready to confirm', sub: 'every invitee answered', good: c('ready_to_confirm') > 0 },
    { key: 'no_commission', value: c('no_commission'), label: 'No commission', sub: 'cannot send until priced', warn: c('no_commission') > 0 },
  ];
}

export function filterRows(rows, { stage = 'all', q = '' } = {}) {
  const s = (q || '').trim().toLowerCase();
  return (rows || []).filter((r) => (stage === 'all' || r.stage === stage) && (!s
    || String(r.deal_id_number || '').includes(s) || (r.deal_name || '').toLowerCase().includes(s) || (r.merchant || '').toLowerCase().includes(s)));
}

/** Which buttons a row offers. Sending needs a commission; resend needs unanswered invitees. */
export function rowActions(r) {
  const o = r.offer || {};
  return {
    canSend: !!r.has_commission,
    canResend: !!r.has_commission && (o.unanswered || 0) > 0,
    review: (o.pending_adjustments || 0) > 0,
    confirm: !!o.ready_to_confirm,
  };
}
